/* eslint-disable array-bracket-newline */
/**
 * Implements a hook that searchesfor wallets by chain
 */
import { useEffect, useState } from 'react';
import { IWallet } from '@kattana-io/common';
import { WalletAPI } from '../../store/createStore';

const useSearchWallets = (
  search: string,
  searchLimit: number,
  chain?: string
) => {
  const [searchedData, setSearchedData] = useState<IWallet[] | null>([]);
  const [loading, setLoading] = useState(false);

  const searchForWallets = async (controller: AbortController) => {
    setLoading(true);
    const data = await WalletAPI.searchForWallets(
      chain || '',
      search,
      searchLimit,
      controller
    );
    if (data) {
      const uniqueWallets = data
        .reduce((cons, wallet) => cons.set(wallet.address, wallet), new Map())
        .values();
      setSearchedData(Array.from(uniqueWallets));
    } else {
      setSearchedData(null);
    }
    if (!controller.signal.aborted) {
      setLoading(false);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    if (search && chain) {
      searchForWallets(controller);
    } else {
      setSearchedData(null);
      setLoading(false);
    }
    return () => controller.abort();
  }, [search, searchLimit, chain]);

  return { searchedData, searchLoading: loading };
};

export default useSearchWallets;
